import { lazy } from "react";
import ErrorBoundary from "@/hoc/ErrorBoundary/ErrorBoundary.jsx";

const TermOfUse = lazy(() => import("./TermOfUse"));

export const termsRoutes = {
  path: "terms-of-use",
  element: <TermOfUse />,
  errorElement: <ErrorBoundary />
};
